/** Blank names retain the default website policy and navigation. */
export const getPrivacyAppName = (search: string): string | undefined =>
  new URLSearchParams(search).get("appName")?.trim() || undefined;

/** The policy body is static HTML, so query values must be escaped before insertion. */
export const escapePolicyText = (value: string): string =>
  value.replace(/[&<>"']/g, (character) => ({
    "&": "&amp;",
    "<": "&lt;",
    ">": "&gt;",
    '"': "&quot;",
    "'": "&#39;",
  }[character] as string));
